export default __webpack_public_path__ + "static/media/icon-stop-marker.2b5844a2.svg";